import { render, staticRenderFns } from "./CreateReportSuccess.vue?vue&type=template&id=ca2c95c4"
import script from "./CreateReportSuccess.vue?vue&type=script&lang=ts"
export * from "./CreateReportSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ZAlert: require('/app/components/zeal/ZAlert/ZAlert.vue').default,CopyButton: require('/app/components/CopyButton.vue').default,ZInput: require('/app/components/zeal/ZInput/ZInput.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,ZDialogGeneric: require('/app/components/zeal/ZDialogGeneric/ZDialogGeneric.vue').default})
